import { toUnit } from '@core/utilities/price.i18n';
import { isEnabled } from '@monolith/legacy/services/features';
import { Cart2, Stock } from '@monolith/legacy/modules/cart-2/types';
import { BrandDiscount } from '@monolith/legacy/types/api/brand-discount';
import { GetOneCartAvailabilityEnum, GetOneCartInventoryPolicyEnum } from '@client/api-internal/data-contracts';
export { snapQuantity } from '@bc/shared/util/snap-quantity';

// `continue` (backorder allowed) and always-in-stock variants have no real ceiling on quantity.
export const isStockLimited = (stock: Stock): boolean => {
  return !stock.isAlwaysInStock && stock.inventoryPolicy !== GetOneCartInventoryPolicyEnum.Continue;
};
export const calculatePercentageMinimumReached = ({ totalAmount, minAmount }) => {
  const total = toUnit(totalAmount);
  const minimum = toUnit(minAmount);
  if (total >= minimum) {
    return 100;
  }
  return (total * 100) / minimum;
};

export const showInternationalShippingReimbursement = (cart, retailer): boolean => {
  return (
    isEnabled('international_shipping_messages') &&
    ((cart?.brand?.country?.iso_code === 'GB' && retailer?.country?.iso_code !== 'GB') ||
      (cart?.brand?.country?.iso_code !== 'GB' && retailer?.country?.iso_code === 'GB')) &&
    cart.minimum.above
  );
};

export const getBrandIdsFromCart = (cart: Cart2): string[] => {
  return cart?.itemAggregates?.data?.map((aggregate) => aggregate.brand?.data?.id);
};

export const getDiscountByBrandUuid = (brandId: string | number, cartBrandsDiscounts: BrandDiscount[]): BrandDiscount => {
  return cartBrandsDiscounts?.find((cartBrand) => {
    return cartBrand.brand_uuid === brandId;
  });
};

export const getBrandLogoPath = (logoImagePath: string): string => {
  return `/brands/rounded/${logoImagePath}`;
};

export const getBrandsFromCart = (cart: Cart2): object[] => {
  return cart.itemAggregates?.data?.map((aggregate) => {
    return {
      brand_uuid: aggregate?.brand?.data?.id,
      product_in_cart_brand_level: aggregate?.itemCount,
      amountBrandBeforeDiscount: aggregate?.totalAmountBeforeDiscount,
      amountBrandAfterDiscount: aggregate?.totalAmountAfterDiscount,
      products: aggregate?.items?.data?.map((purchasingListItem) => {
        const product = {
          brand_uuid: aggregate?.brand?.data?.id,
          product_uuid: purchasingListItem.productID,
          ...purchasingListItem,
        };
        delete product.productID;

        return product;
      }),
    };
  });
};

export const getBrandsFromCartWithoutProductsDetails = (cart: Cart2): object[] => {
  return cart?.itemAggregates?.data?.map((aggregate) => {
    return {
      brand_uuid: aggregate?.brand?.data?.id,
      product_in_cart_brand_level: aggregate?.itemCount,
      amountBrandBeforeDiscount: aggregate?.totalAmountBeforeDiscount,
      amountBrandAfterDiscount: aggregate?.totalAmountAfterDiscount,
      products: aggregate?.items?.data?.length,
    };
  });
};


export const getAllOutOfStockProducts = (cart: Cart2): string[] =>
  cart?.itemAggregates?.data?.flatMap((aggregate) =>
    aggregate?.items?.data
      ?.filter(({ purchasableItem }) => purchasableItem.data.availability === GetOneCartAvailabilityEnum.OutOfStock)
      .map((item) => item?.purchasableItem?.data?.id)
  );
